import { envConfig } from '@globals/env'
import { loadGainsightPx } from '@globals/gainsightPx'
import { captureLogRocketException, loadLogRocket } from '@globals/logRocket'
import { initAPI } from '@kudos/http-client'
// eslint-disable-next-line local/require-direct-mui-imports
import { LicenseInfo } from '@mui/x-license'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { App } from './App'

// Initialize the API with base URL and default locale for this environment
initAPI({ apiUrl: envConfig.API_URL, apiLocale: 'en' })

// Set the license key for the MUI X pro components
LicenseInfo.setLicenseKey(envConfig.MUI_PRO_KEY)

// Install the Gainsight PX tag (no-op outside the production deploy).
loadGainsightPx()

// SYN-7849 spike: inject the LogRocket session-replay + debugging POC loader.
// No-op (nothing injected or fetched) unless a LOGROCKET_APP_ID is configured
loadLogRocket()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
  // Reports every error an error boundary catches, anywhere in the tree — the
  // root is the only place React exposes this. A boundary swallows the crash
  // before it reaches the window, so LogRocket's automatic capture (uncaught
  // exceptions + unhandled rejections) never sees one, and an outer boundary
  // cannot help either: React stops at the innermost boundary. Rollbar gets
  // these from `@rollbar/react`'s `ErrorBoundary`, which reports from its own
  // `componentDidCatch`.
  onCaughtError: (error, errorInfo) => {
    // eslint-disable-next-line no-console -- restores React's default logging, which defining onCaughtError replaces
    console.error(error)

    if (error instanceof Error) {
      captureLogRocketException(error, errorInfo.componentStack)
    }
  },
})

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
